import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSpinnerComponent } from './inline-spinner.component';

@NgModule({
  declarations: [InlineSpinnerComponent],
  imports: [CommonModule],
  exports: [InlineSpinnerComponent]
})
export class InlineSpinnerModule {}
